<template>
  <section class="hero-section">
    <div class="hero-background">
      <div class="gradient-overlay"></div>
      <div class="pixel-grid"></div>
    </div>
    
    <div class="hero-content">
      <div class="hero-text">
        <h1 class="hero-title">
          <span class="title-line">X CARS</span>
          <span class="title-subtitle">Your First Dream NFT on X Layer</span>
        </h1>
        
        <p class="hero-description">
          X Layer's first high-quality 10k original NFT collection featuring hundreds of unique climate landscapes and classic vehicle models. Embark on a unique journey of freedom, powered by consensus and community-driven innovation.
        </p>
        
        <div class="hero-features">
          <div class="feature-item">
            <!-- <div class="feature-icon">🌍</div> -->
            <span>Hundreds of Unique Climate Landscapes</span>
          </div>
          <div class="feature-item">
            <!-- <div class="feature-icon">🚗</div> -->
            <span>Hundreds of Classic Vehicle Models</span>
          </div>
          <div class="feature-item">
            <!-- <div class="feature-icon">🚀</div> -->
            <span>Powered by Consensus & Community</span>
          </div>
        </div>
      </div>
      
      <div class="hero-visual">
        <div class="gif-showcase">
          <div class="showcase-grid">
            <div class="gif-card" v-for="(gif, index) in featuredGifs" :key="index">
              <div class="gif-container">
                <img 
                  :src="gif.src" 
                  :alt="gif.name"
                  class="gif-image"
                  loading="lazy"
                  @load="onImageLoad(gif.name)"
                  @error="onImageError(gif.name, gif.src)"
                />
              </div>
              <div class="gif-info">
                <span class="gif-name">{{ gif.name }}</span>
                <!-- <div class="debug-info">{{ gif.src }}</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="scroll-indicator">
      <div class="scroll-arrow">
        <svg class="w-6 h-6 text-white animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
        </svg>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const featuredGifs = ref([
  { name: 'X CARS #56', src: '/img/200px56.gif' },
  { name: 'X CARS #90', src: '/img/200px90.gif' },
  { name: 'X CARS #127', src: '/img/200px127.gif' },
  { name: 'X CARS #129', src: '/img/200px129.gif' },
  { name: 'X CARS #194', src: '/img/200px194.gif' },
  { name: 'X CARS #402', src: '/img/200px402.gif' }
])

const onImageLoad = (name: string) => {
  // console.log(`Image loaded successfully: ${name}`)
}

const onImageError = (name: string, src: string) => {
  // console.error(`Failed to load image: ${name}, src: ${src}`)
}
</script>

<style scoped>
.hero-section {
  @apply relative min-h-screen flex items-center justify-center overflow-hidden;
}

.hero-background {
  @apply absolute inset-0;
}

/* .gradient-overlay {
  @apply absolute inset-0 bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900;
} */

.pixel-grid {
  @apply absolute inset-0 opacity-10;
  background-image: 
    linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px);
  background-size: 20px 20px;
}

.hero-content {
  @apply relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center;
}

.hero-text {
  @apply space-y-8;
}

.hero-title {
  @apply space-y-2;
}

.title-line {
  @apply block text-6xl md:text-8xl font-bold text-white;
  font-family: 'Arial Black', sans-serif;
  letter-spacing: -0.02em;
}

.title-subtitle {
  @apply block text-xl md:text-2xl text-gray-300 font-light;
}

.hero-description {
  @apply text-lg text-gray-300 leading-relaxed max-w-2xl;
}

.hero-features {
  @apply space-y-4;
}

.feature-item {
  @apply flex items-center space-x-3 text-gray-200;
}

.feature-icon {
  @apply text-2xl;
}

.hero-visual {
  @apply flex justify-center;
}

.gif-showcase {
  @apply relative;
}

.showcase-grid {
  @apply grid grid-cols-2 md:grid-cols-3 gap-4;
}

.gif-card {
  @apply bg-gray-800 rounded-lg p-3 border border-gray-700 hover:border-purple-500 transition-all duration-300 transform hover:scale-105;
}

.gif-container {
  @apply aspect-square mb-2 overflow-hidden rounded-lg;
}

.gif-image {
  @apply w-full h-full object-cover;
}

.gif-info {
  @apply text-center;
}

.gif-name {
  @apply text-sm text-gray-300 font-medium;
}

.debug-info {
  @apply text-xs text-red-400 mt-1 break-all;
}

.scroll-indicator {
  @apply absolute bottom-8 left-1/2 transform -translate-x-1/2;
}

.scroll-arrow {
  @apply cursor-pointer;
}

/* Animations */
@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

.gif-card:nth-child(odd) {
  animation: float 3s ease-in-out infinite;
}

.gif-card:nth-child(even) {
  animation: float 3s ease-in-out infinite 1.5s;
}
</style>